import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Makes extends Component {
  render() {
    return (
      <EntityList apiRoute='api/makes' title='Remorque - Marques' editTitle='Marque' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Makes;



/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/makes.js
 **/